import { render, staticRenderFns } from "./budget-sum-calc-income-table.vue?vue&type=template&id=40a188ec&scoped=true&"
import script from "./budget-sum-calc-income-table.vue?vue&type=script&lang=ts&"
export * from "./budget-sum-calc-income-table.vue?vue&type=script&lang=ts&"
import style0 from "./budget-sum-calc-income-table.vue?vue&type=style&index=0&id=40a188ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a188ec",
  null
  
)

export default component.exports